import { Box, Button, type Theme, alpha } from "@mui/material";
import { styled } from "styled-components";

export const StyledButton = styled(Button)<{ $theme: Theme; $isStarting: boolean }>(({ $theme, $isStarting }) => ({
  height: "40px",
  textTransform: "none",
  borderRadius: "32px",
  padding: "0 16px",
  fontSize: "14px",
  fontWeight: 500,
  lineHeight: "20px",
  fontFamily: "Inter",
  fontStyle: "normal",
  display: "inline-flex",
  alignItems: "center",
  gap: "16px",
  cursor: $isStarting ? "default" : "pointer",
  backgroundColor: $isStarting ? alpha($theme.palette.common.white, 0.65) : alpha($theme.palette.common.black, 0.65),
  color: $isStarting ? $theme.palette.common.black : $theme.palette.common.white,
  "& .MuiButton-startIcon": {
    margin: 0,
    width: "24px",
    height: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  "& .MuiButton-startIcon svg": {
    fontSize: "16px",
  },
  "&.Mui-disabled": {
    color: $isStarting ? $theme.palette.common.black : $theme.palette.common.white,
    backgroundColor: $isStarting ? alpha($theme.palette.common.white, 0.65) : alpha($theme.palette.common.black, 0.65),
  },
  "&:hover": {
    backgroundColor: $isStarting ? $theme.palette.common.white : $theme.palette.common.black,
  },
}));

export const StartingPointWrapper = styled(Box)<{ $withDrawerOffset: boolean; $isOnCustomize: boolean }>(
  ({ $withDrawerOffset, $isOnCustomize }) => ({
    position: "absolute",
    top: $isOnCustomize ? "96px" : "56px",
    right: $withDrawerOffset ? "240px" : 0,
    padding: "16px",
  }),
);
